/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyMonitoredObjectSharing,
    ReadOnlyMonitoredObjectSharingFromJSON,
    ReadOnlyMonitoredObjectSharingFromJSONTyped,
    ReadOnlyMonitoredObjectSharingToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20027
 */
export interface InlineResponse20027 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20027
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20027
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20027
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyMonitoredObjectSharing>}
     * @memberof InlineResponse20027
     */
    results: Array<ReadOnlyMonitoredObjectSharing>;
}

export function InlineResponse20027FromJSON(json: any): InlineResponse20027 {
    return InlineResponse20027FromJSONTyped(json, false);
}

export function InlineResponse20027FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20027 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyMonitoredObjectSharingFromJSON)),
    };
}

export function InlineResponse20027ToJSON(value?: InlineResponse20027 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyMonitoredObjectSharingToJSON)),
    };
}


